import React from "react";
import logo from "../Images/E-mas-logo.png";
import banner from "../Images/arm.jpg";
import icon1 from "../Images/emas-icons/icons8-portrait-mode-scanning-64.png";
import icon2 from "../Images/emas-icons/icons8-candidate-selection-64.png";
import icon3 from "../Images/emas-icons/icons8-accounts-50.png";
import icon4 from "../Images/emas-icons/icons8-reports-64.png";
import icon5 from "../Images/emas-icons/icons8-referral-50.png";
import icon6 from "../Images/emas-icons/icons8-law-court-48.png";

export default function Emas() {
  return (
    <>
      <>
        <section className="wrapper">
          <div className="container pt-20 xl:pt-28 lg:pt-28 md:pt-28   ">
            <div className="flex flex-wrap mx-[-15px] xsm:mt-[-50px] mt-[-80px] md:mx-[-20px] xl:mx-[-35px] items-center mb-10  lg:!mb-14 md:!mb-14">
              <div className="xl:w-5/12 lg:w-5/12 w-full flex-[0_0_auto] xl:px-[35px] lg:px-[20px] md:px-[20px] px-[15px] max-w-full mt-[80px]">
                <div className="flex flex-wrap mx-[-15px] xl:mx-[-12.5px] lg:mx-[-12.5px] md:mx-[-12.5px] mt-[-25px]">
                  <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full flex-[0_0_auto] xl:px-[12.5px] lg:px-[12.5px] md:px-[12.5px] px-[15px] max-w-full mt-[25px]"></div>
                  {/*/column */}
                  <div className="xl:w-10/12 lg:w-6/12 md:w-6/12 w-full flex-[0_0_auto] xl:px-[12.5px] lg:px-[12.5px] md:px-[12.5px] px-[15px] max-w-full !self-end mt-[25px]">
                    <figure className="rounded-[0.4rem]">
                      <img
                        className="rounded-[0.4rem]"
                        src={banner}
                        alt="image"
                      />
                    </figure>
                  </div>
                  {/*/column */}

                  {/*/column */}
                </div>
                {/*/.row */}
              </div>
              {/*/column */}
              <div className="xl:w-6/12 lg:w-6/12 w-full flex-[0_0_auto] xl:px-[35px] lg:px-[20px] md:px-[20px] px-[15px] max-w-full mt-[80px]">
                <h2 className="text-[0.8rem] uppercase text-[#3f78e0] !mb-3 !leading-[1.35]">
                  What is E-mas?
                </h2>
                <h3 className="text-[calc(1.325rem_+_0.9vw)] font-bold !leading-[1.25] xl:text-[2rem] mb-5">
                  About E-MAS{" "}
                </h3>
                <p className="!mb-6">
                  E-mas (ECHS Management and Administrative System) is a
                  comprehensive software solution designed to streamline and
                  automate the candidate selection process for ECHS Pangode
                  Military. Built with a focus on precision, efficiency, and
                  user-friendliness, e-mas revolutionizes traditional
                  recruitment methods, ensuring a seamless experience for both
                  administrators and applicants.
                </p>

                {/*/.row */}
              </div>
              {/*/column */}
            </div>
            {/*/.row */}
            <div className="flex flex-wrap mx-[-15px] xl:mx-[-35px] lg:mx-[-20px] mt-[-30px] mb-7 xl:!mb-9 lg:!mb-9 md:!mb-9">
              <div className="xl:w-4/12 lg:w-4/12 w-full flex-[0_0_auto] xl:px-[35px] lg:px-[20px] md:px-[20px] px-[15px] max-w-full mt-[30px]">
                <div className="flex flex-row">
                  <div>
                    <div className="icon btn btn-block pointer-events-none btn-soft-primary !mr-4 !w-10 !h-10">
                      {" "}
                      <span className="number text-[0.9rem] table-cell text-center align-middle font-bold mx-auto my-0">
                        1
                      </span>{" "}
                    </div>
                  </div>
                  <div>
                    <h3>Our Vision</h3>
                    <p className="!mb-2">
                      To be a leader in delivering innovative and efficient
                      recruitment solutions, empowering ECHS Pangode Military to
                      select the best candidates with precision and
                      transparency.
                    </p>
                  </div>
                </div>
              </div>
              {/*/column */}
              <div className="xl:w-4/12 lg:w-4/12 w-full flex-[0_0_auto] xl:px-[35px] lg:px-[20px] md:px-[20px] px-[15px] max-w-full mt-[30px]">
                <div className="flex flex-row">
                  <div>
                    <div className="icon btn btn-block pointer-events-none btn-soft-primary !mr-4 !w-10 !h-10">
                      {" "}
                      <span className="number text-[0.9rem] table-cell text-center align-middle font-bold mx-auto my-0">
                        2
                      </span>{" "}
                    </div>
                  </div>
                  <div>
                    <h3>Our Mission</h3>
                    <p className="!mb-2">
                      To streamline and automate the recruitment process,
                      ensuring accuracy, efficiency, and user-friendliness,
                      while providing a seamless experience for administrators
                      and applicants.
                    </p>
                  </div>
                </div>
              </div>
              {/*/column */}
              <div className="xl:w-4/12 lg:w-4/12 w-full flex-[0_0_auto] xl:px-[35px] lg:px-[20px] md:px-[20px] px-[15px] max-w-full mt-[30px]">
                <div className="flex flex-row">
                  <div>
                    <div className="icon btn btn-block pointer-events-none btn-soft-primary !mr-4 !w-10 !h-10">
                      {" "}
                      <span className="number text-[0.9rem] table-cell text-center align-middle font-bold mx-auto my-0">
                        3
                      </span>{" "}
                    </div>
                  </div>
                  <div>
                    <h3>Our Values</h3>
                    <p className="!mb-2">
                      We prioritize transparency, innovation, and efficiency to
                      enhance recruitment processes. Our system is designed to
                      optimize workflows and deliver a reliable, user-friendly
                      experience.
                    </p>
                  </div>
                </div>
              </div>
              {/*/column */}
            </div>
            {/*/.row */}
          </div>
        </section>
        {/* /section */}
      </>

      <section
        className="wrapper "
        style={{ backgroundColor: "rgb(230, 229, 239)" }}
      >
        <div className="container pt-20 xl:pt-28 lg:pt-28 md:pt-28 pb-20 xl:pb-20 lg:pb-23 md:pb-20">
          <div className="flex flex-wrap mx-[-15px]  !text-center">
            <div className="md:w-10/12 lg:w-7/12 xl:w-7/12 w-full flex-[0_0_auto] px-[15px] max-w-full !mx-auto !relative">
              <img
                src="../../assets/img/svg/doodle5.svg"
                className="!w-[5rem] absolute hidden xl:block lg:block"
                data-delay={1800}
                style={{ bottom: "-60%", right: "10%" }}
                alt="image"
              />
              <img
                src="../../assets/img/svg/doodle6.svg"
                className="!h-[5rem] !absolute hidden xl:block lg:block"
                data-delay={1800}
                style={{ top: "-40%", left: "-5%" }}
                alt="image"
              />
              <h2 className="text-[0.8rem] tracking-[0.02rem] uppercase text-[#aab0bc] !mb-3 !leading-[1.35]">
                Why Choose e-mas?
              </h2>
              <h3 className="text-[calc(1.325rem_+_0.9vw)] font-bold !leading-[1.2] xl:text-[2rem] !mb-8 xl:!px-6">
                {" "}
                <span className="text-gradient gradient-7">
                  Efficiency, Accuracy, and Control{" "}
                </span>
                – all in one platform.
              </h3>
            </div>
            {/* /column */}
          </div>
          {/* /.row */}
          <div className="flex flex-wrap mx-[-15px]">
            <div className="xxl:w-11/12 w-full flex-[0_0_auto] px-[15px] max-w-full !mx-auto">
              <div className="flex flex-wrap mx-[-15px] mt-[-50px] xl:mt-0 lg:mt-0 !text-center items-center">
                <div className="md:w-6/12 lg:w-4/12 xl:w-4/12 w-full flex-[0_0_auto] px-[15px] max-w-full !mx-auto mb-[-2.5rem] lg:!mb-0 xl:!mb-0 mt-[50px] xl:mt-0 lg:mt-0">
                  <figure className="mx-auto">
                    <img src={logo} alt="image" />
                  </figure>
                </div>
                {/* /column */}
                <div className="w-full xl:hidden lg:hidden px-[15px] mt-[50px] xl:mt-0 lg:mt-0" />
                <div className="md:w-6/12 lg:w-4/12 xl:w-4/12 w-full flex-[0_0_auto] px-[15px] max-w-full lg:!-order-1 xl:!-order-1 mt-[50px] xl:mt-0 lg:mt-0">
                  <div className="!mb-8">
                    <span className="xl:text-[3rem] text-[calc(1.425rem_+_2.1vw)] !leading-none mb-3 font-medium text-gradient gradient-7">
                      01
                    </span>
                    <h4 className="text-[1rem]">Accuracy & Speed</h4>
                    <p className="mb-0 xl:!px-7">
                      Eliminate errors and delays associated with manual data
                      entry and processing.
                    </p>
                  </div>
                  {/* /div */}
                  <div>
                    <span className="xl:text-[3rem] text-[calc(1.425rem_+_2.1vw)] !leading-none mb-3 font-medium text-gradient gradient-7">
                      02
                    </span>
                    <h4 className="text-[1rem]">Centralized Data Management</h4>
                    <p className="mb-0 xl:!px-7">
                      Access all candidate information, reports, and financial
                      data from a single, secure location.
                    </p>
                  </div>
                  {/* /div */}
                </div>
                {/* /column */}
                <div className="md:w-6/12 lg:w-4/12 xl:w-4/12 w-full flex-[0_0_auto] px-[15px] max-w-full mt-[50px] xl:mt-0 lg:mt-0">
                  <div className="!mb-8">
                    <span className="xl:text-[3rem] text-[calc(1.425rem_+_2.1vw)] !leading-none mb-3 font-medium text-gradient gradient-7">
                      03
                    </span>
                    <h4 className="text-[1rem]">User-Friendly Interface</h4>
                    <p className="mb-0 xl:!px-7">
                      Designed for ease of use, e-mas simplifies complex
                      processes with an intuitive interface and guided
                      workflows.
                    </p>
                  </div>
                  {/* /div */}
                  <div>
                    <span className="xl:text-[3rem] text-[calc(1.425rem_+_2.1vw)] !leading-none mb-3 font-medium text-gradient gradient-7">
                      04
                    </span>
                    <h4 className="text-[1rem]">Tailored for Military Needs</h4>
                    <p className="mb-0 xl:!px-7">
                      Specifically developed to meet the unique requirements of
                      ECHS Pangode Military, ensuring compliance with protocols
                      and procedures.
                    </p>
                  </div>
                  {/* /div */}
                </div>
                {/* /column */}
              </div>
              {/* /.row */}
            </div>
            {/* /column */}
          </div>
          {/* /.row */}
        </div>
      </section>
      <section className="wrapper !bg-[#ffffff] ">
        <div className="container pt-10 xl:pt-10 lg:pt-10 ">
          <div className="flex flex-wrap mx-[-15px] xsm:mt-[-50px] mt-[-80px] md:mx-[-20px] xl:mx-[-35px] !text-center items-center">
            <div className="xl:w-6/12 lg:w-6/12 w-full flex-[0_0_auto] xl:px-[35px] lg:px-[20px] px-[15px] max-w-full mt-[80px]">
              <div className="flex flex-wrap mx-[-15px] xl:mx-[-12.5px] lg:mx-[-12.5px] md:mx-[-12.5px] mt-[-25px]">
                <div className="w-full flex-[0_0_auto] xl:px-[12.5px] lg:px-[12.5px] md:px-[12.5px] px-[15px] max-w-full mt-[25px]"></div>
                {/*/column */}
                <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full flex-[0_0_auto] xl:px-[12.5px] lg:px-[12.5px] md:px-[12.5px] px-[15px] max-w-full mt-[25px]">
                  <figure className="rounded-[0.4rem]"></figure>
                </div>
                {/*/column */}

                {/*/column */}
              </div>
              {/*/.row */}
            </div>
            {/*/column */}
            <div className="xl:w-12/12 lg:w-12/12 w-full flex-[0_0_auto] xl:px-[35px] lg:px-[20px] px-[15px] max-w-full mt-[80px]">
              <h2 className="text-[0.8rem] tracking-[0.02rem] uppercase text-[#aab0bc] ">
                What Makes Us Different?
              </h2>
              <h3 className="text-[calc(1.325rem_+_0.9vw)] font-bold !leading-[1.25] xl:text-[2rem] mb-10">
                We bring{" "}
                <span className="!relative z-[2] after:content-[''] after:absolute after:z-[-1] after:block after:bg-no-repeat after:bg-bottom after:bottom-[-0.1em] after:w-[110%] after:h-[0.3em] after:-translate-x-2/4 after:left-2/4  style-2 yellow">
                  solutions
                </span>{" "}
                to make <br></br>life easier for ECHS Cell
              </h3>
              <div className="flex flex-wrap mx-[-15px] mt-[-40px]">
                <div className="xl:w-4/12 lg:w-4/12 md:w-4/12 w-full flex-[0_0_auto] px-[15px] max-w-full mt-[40px]">
                  <div className="flex flex-row">
                    <div>
                      <img
                        src={icon1}
                        className="svg-inject icon-svg !w-[1.8rem] !h-[1.8rem]  solid-mono text-[#e668b3] text-fuchsia !mr-4"
                        alt="image"
                      />
                    </div>
                    <div>
                      <h4 className="!mb-1">
                        Application Scanning & Management
                      </h4>
                      <p className="!mb-0">
                        e-mas digitizes and scans all incoming applications,
                        enabling quick and efficient data processing without
                        manual intervention.{" "}
                      </p>
                    </div>
                  </div>
                </div>
                {/*/column */}
                <div className="xl:w-4/12 lg:w-4/12 md:w-4/12 w-full flex-[0_0_auto] px-[15px] max-w-full mt-[40px]">
                  <div className="flex flex-row">
                    <div>
                      <img
                        src={icon2}
                        className="svg-inject icon-svg !w-[1.8rem] !h-[1.8rem]  solid-mono text-[#a07cc5] text-violet !mr-4"
                        alt="image"
                      />
                    </div>
                    <div>
                      <h4 className="!mb-1">End-to-End Candidate Selection</h4>
                      <p className="!mb-0">
                        Manage the entire recruitment lifecycle—from initial
                        application submission to final selection—within a
                        single, integrated platform.{" "}
                      </p>
                    </div>
                  </div>
                </div>
                {/*/column */}
                <div className="xl:w-4/12 lg:w-4/12 md:w-4/12 w-full flex-[0_0_auto] px-[15px] max-w-full mt-[40px]">
                  <div className="flex flex-row">
                    <div>
                      <img
                        src={icon3}
                        className="svg-inject icon-svg !w-[1.8rem] !h-[1.8rem]  solid-mono text-[#45c4a0] text-green !mr-4"
                        alt="image"
                      />
                    </div>
                    <div>
                      <h4 className="!mb-1">Accounts & Financial Tracking</h4>
                      <p className="!mb-0">
                        Monitor and manage monthly accounts, including
                        expenditure, total available balance, and percentage
                        utilization, providing a clear financial overview at all
                        times.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="xl:w-4/12 lg:w-4/12 md:w-4/12 w-full flex-[0_0_auto] px-[15px] max-w-full mt-[40px]">
                  <div className="flex flex-row">
                    <div>
                      <img
                        src={icon4}
                        className="svg-inject icon-svg !w-[1.8rem] !h-[1.8rem]  solid-mono text-[#f78b77] text-orange !mr-4"
                        alt="image"
                      />
                    </div>
                    <div>
                      <h4 className="!mb-1">Daily Reporting (DASR)</h4>
                      <p className="!mb-0">
                        Track and update daily administrative status reports
                        (DASR) for seamless candidate management and operational
                        updates
                      </p>
                    </div>
                  </div>
                </div>
                {/*/column */}
                <div className="xl:w-4/12 lg:w-4/12 md:w-4/12 w-full flex-[0_0_auto] px-[15px] max-w-full mt-[40px]">
                  <div className="flex flex-row">
                    <div>
                      <img
                        src={icon5}
                        className="svg-inject icon-svg !w-[1.8rem] !h-[1.8rem]  solid-mono text-[#45c4a0] text-green !mr-4"
                        alt="image"
                      />
                    </div>
                    <div>
                      <h4 className="!mb-1">Referral </h4>
                      <p className="!mb-0">
                        Maintain comprehensive records of candidate referrals,
                        including referral sources, dates, and statuses,
                        ensuring accurate documentation and streamlined
                        follow-up.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="xl:w-4/12 lg:w-4/12 md:w-4/12 w-full flex-[0_0_auto] px-[15px] max-w-full mt-[40px]">
                  <div className="flex flex-row">
                    <div>
                      <img
                        src={icon6}
                        className="svg-inject icon-svg !w-[1.8rem] !h-[1.8rem]  solid-mono text-[#a07cc5] text-violet !mr-4"
                        alt="image"
                      />
                    </div>
                    <div>
                      <h4 className="!mb-1">Court Case Tracking</h4>
                      <p className="!mb-0">
                        Track and manage all court cases related to candidates,
                        with detailed case information, progress updates, and
                        quick access to necessary documents for timely
                        resolution.{" "}
                      </p>
                    </div>
                  </div>
                </div>

                {/*/column */}
              </div>
              {/*/.row */}
            </div>
            {/*/column */}
          </div>
          {/*/.row */}
        </div>
        {/* /.container */}
      </section>

      {/* /section */}
    </>
  );
}
